import React, { useState, useContext } from "react";
import Navbar from "../../components/navbar/Navbar";
import TextField from "@mui/material/TextField";
import Sidebar from "../../components/sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import { MenuContext } from "../../context/MenuContext";
//
import Button from "@mui/material/Button";
// import "../AddNewUser.scss";
// import axios from "axios";
import axios from "../../API/axios";
const EDIT_USER = "/admin/edit-user";

const EditUser = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { userToCreate, setSucces } = useContext(MenuContext);
  // console.log(userToCreate);
  const [message, setMessage] = useState({});
  const [errMsg, setErrMsg] = useState("");
  const [values, setValues] = useState({
    firstName: userToCreate ? userToCreate?.firstName : "",
    lastName: userToCreate ? userToCreate?.lastName : "",
    age: userToCreate ? userToCreate?.age : "",
    gender: userToCreate ? userToCreate?.gender : "",
    email: userToCreate ? userToCreate?.email : "",
    address: userToCreate ? userToCreate?.address : "",
    dialCode: userToCreate ? userToCreate?.dialCode : "",
    phoneNumber: userToCreate ? userToCreate?.phoneNumber : "",
  });

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const {
      firstName,
      lastName,
      age,
      gender,
      email,
      address,
      dialCode,
      phoneNumber,
    } = values;

    try {
      const response = await axios.patch(
        EDIT_USER,
        {
          updates: {
            firstName,
            lastName,
            age,
            gender,
            address,
            dialCode,
            phoneNumber,
          },
          email,
        },
        {
          headers: {
            token: `${JSON.parse(localStorage.getItem("data22"))}`,
          },
        }
      );
      setMessage(response?.data);
      setIsLoading(false);
      setValues({
        firstName: "",
        lastName: "",
        age: "",
        gender: "",
        email: "",
        address: "",
        dialCode: "",
        phoneNumber: "",
      });
      console.log(response);
      setSucces((prev) => !prev);
    } catch (err) {
      // console.log(err?.response?.data?.code);
      if (err?.response?.data?.code === 409) {
        setErrMsg("User With This Email Already Exist");
        setIsLoading(false);
      } else if (!err?.response) {
        setErrMsg("No Server Response");
        setIsLoading(false);
      } else if (err.response?.status === 401) {
        setErrMsg("Unauthorized");
        console.log(errMsg);
        setIsLoading(false);
      } else {
        setErrMsg("Login Failed");
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="newTrip">
      <Sidebar />
      <div className="newContainer">
        <Navbar />

        <div style={{ marginTop: "0rem" }} className="bottom">
          <form className="newForm">
            <div className="form-group">
              <TextField
                fullWidth
                label="firstName"
                name="firstName"
                id="fullWidth"
                value={values?.firstName}
                style={{ margin: "1rem 0" }}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="lastName"
                name="lastName"
                id="fullWidth"
                value={values?.lastName}
                style={{ margin: "1rem 0" }}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <TextField
                fullWidth
                label="Date Of Birth"
                name="age"
                id="fullWidth"
                value={values?.age.slice(0, 10)}
                style={{ margin: "1rem 0" }}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="gender"
                name="gender"
                id="fullWidth"
                value={values?.gender}
                style={{ margin: "1rem 0" }}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <TextField
                fullWidth
                type="email"
                label="email"
                name="email"
                value={values?.email}
                id="fullWidth"
                style={{ margin: "1rem 0" }}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="address"
                name="address"
                id="fullWidth"
                value={values?.address}
                style={{ margin: "1rem 0" }}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <TextField
                fullWidth
                label="dial Code"
                name="dialCode"
                value={values?.dialCode}
                id="fullWidth"
                style={{ margin: "1rem 0" }}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Phone Number"
                name="phoneNumber"
                id="fullWidth"
                value={values?.phoneNumber}
                style={{ margin: "1rem 0" }}
                onChange={handleChange}
              />
            </div>
            <Button variant="contained" onClick={handleSubmit}>
              {isLoading ? "Updating" : "Edit"}
            </Button>
            <div style={{ color: "green", margin: "1.5rem" }}>
              <p>{message?.msg}</p>
              {errMsg && <p>{errMsg}</p>}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
